module.exports = (__parcel__import__("lwfUK")).then(() => parcelRequire('lmhgI'));